import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full text-sm" }
const _hoisted_2 = {
  class: "border border-gray-300 bg-gray-200 dark:border-dark-400 dark:bg-dark-500",
  style: {"padding":"2px 12px 2px 12px","border-radius":"1rem 1rem 0 0"}
}
const _hoisted_3 = { class: "text-gray-800 dark:text-dark-text" }
const _hoisted_4 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputArea = _resolveComponent("InputArea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.label), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_InputArea, {
        class: "shadow-md border border-gray-300 text-gray-800 dark:border-dark-400 dark:text-dark-text dark:bg-dark-400",
        isEditable: _ctx.isEditable,
        onChange: _ctx.onChange,
        style: {"height":"100px","border-radius":"0 0 1rem 1rem"},
        value: _ctx.value
      }, null, 8, ["isEditable", "onChange", "value"])
    ])
  ]))
}